// Progress file (.apolo/progress.md) — repo as system of record (P2/P10 do
// roadmap): todo run que EDITOU arquivos deixa um registro mecânico que a
// próxima sessão lê no init. Puro (sem window/fs) — o loop faz o I/O.

export const PROGRESS_PATH = '.apolo/progress.md';
const HEADER = '# Progresso (gerado pelo Apolo — mais recente primeiro)';
const MAX_ENTRIES = 30; // poda: entropia acumulada vira ruído, não memória

const clip = (s, n) => (s.length > n ? s.slice(0, n - 1) + '…' : s);

/** Monta a entrada markdown de um run. `files` = paths editados; `features` = summarizeFeatures() ou null. */
export function buildProgressEntry({ now, taskText, stopReason, files = [], features = null }) {
  const stamp = now instanceof Date ? now.toISOString().slice(0, 16).replace('T', ' ') : String(now);
  const task = clip(String(taskText || 'sem descrição').replace(/\s+/g, ' ').trim(), 160);
  const lines = [`## ${stamp} — ${task}`, `- resultado: ${stopReason || 'desconhecido'}`];
  if (files.length) lines.push(`- arquivos (${files.length}): ${clip(files.join(', '), 400)}`);
  if (features && features.total) lines.push(`- features: ${features.passing}/${features.total} passing, ${features.failing} failing, ${features.blocked} blocked`);
  return lines.join('\n');
}

/**
 * Prepende a entrada sob o header, mantendo no máximo MAX_ENTRIES entradas.
 * Notas manuais ACIMA da 1ª entrada sobrevivem (review Wave-A P1). Limitação
 * aceita: "## " dentro de code fence contaria como entrada — o arquivo é
 * machine-owned e buildProgressEntry nunca gera fences.
 */
export function mergeProgress(existingText, entry) {
  const body = typeof existingText === 'string' ? existingText : '';
  const firstEntry = body.search(/^## /m);
  const rawPre = firstEntry === -1 ? body : body.slice(0, firstEntry);
  const preamble = rawPre.replace(HEADER, '').trim();
  const olds = (firstEntry === -1 ? '' : body.slice(firstEntry))
    .split(/^## /m).filter(Boolean).map((chunk) => '## ' + chunk.trimEnd());
  const kept = olds.slice(0, MAX_ENTRIES - 1);
  return [HEADER, '', ...(preamble ? [preamble, ''] : []), entry, '', ...kept.flatMap((e) => [e, ''])]
    .join('\n').replace(/\n{3,}/g, '\n\n');
}
